import moment from "moment";

function Thanks() {
  return (
    <div
      id="thanks"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h4>
          Amor,
          <br />
          <br />
          Obrigado por por tornar meus dias muito melhores, por ter olhado com
          atenção e carinho para o nosso relacionamento, por se preocupar com
          cada detalhe, por me fazer acreditar que tudo pode ser bom, por
          confiar em mim e me dar segurança para confiar, por trazer brilho aos
          meus olhos, por ser você e por permitir que eu seja eu mesmo.
          <br />
          <br />
          Quero dizer que me sinto muito feliz em poder compartilhar a minha
          vida com você e que cada dia mais eu tenho certeza de que é com você
          que eu quero construir a <s>minha</s> nossa história.
        </h4>
        <br />
        <h3>Eu te amo!</h3>
        {moment().isSame("2025-06-12", "day") && (
          <h4>Feliz dia dos namorados 😘</h4>
        )}
      </div>
    </div>
  );
}

export default Thanks;
